module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/jszip/~/core-js/library/modules/_a-function.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_a-function.js
// module chunks = 3